"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const scale_1 = require("../../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const DeleteAccountOneScreen = () => {
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    return (react_1.default.createElement(react_native_1.View, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
        } },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: 'アカウント削除', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, null) }),
        react_1.default.createElement(react_native_1.ScrollView, { style: { flex: 1 }, contentContainerStyle: { paddingBottom: inset.bottom + (0, scale_1.scale)(100) }, showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row' } },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(16),
                            lineHeight: (0, scale_1.moderateScale)(24),
                            color: '#292A33',
                            fontWeight: '300',
                            paddingLeft: (0, scale_1.scale)(8),
                        } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u3092\u884C\u3046\u524D\u306B")),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(12),
                    } }, "\u8CB4\u91CD\u306A\u7D4C\u9A13\u3068\u77E5\u898B\u306E\u5171\u6709"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(8),
                    } }, "\u3042\u306A\u305F\u304C\u7BC9\u3044\u305F\u7D4C\u9A13\u3084\u77E5\u898B\u306F\u3001\u4ED6\u306E\u521D\u5FC3\u8005\u306B\u3068\u3063\u3066\u5927\u304D\u306A\u52A9\u3051\u3068\u306A\u308A\u307E\u3059\u3002"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5B8C\u5168\u306A\u524A\u9664\u3067\u306F\u306A\u304F\u3001\u4E00\u6642\u7684\u306A\u4E2D\u6B62\u3092\u63A8\u5968\u3057\u3066\u304A\u308A\u307E\u3059\u3002"),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(12),
                    } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u7DAD\u6301\u306F\u7121\u6599"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(8),
                    } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u7DAD\u6301\u306B\u8CBB\u7528\u306F\u304B\u304B\u308A\u307E\u305B\u3093\u3002"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u5229\u7528\u3092\u4E00\u6642\u7684\u306B\u4E2D\u65AD\u3057\u3001\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u3044\u3064\u3067\u3082\u518D\u958B\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(12),
                    } }, "\u30C7\u30FC\u30BF\u306E\u53D6\u308A\u6271\u3044"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(8),
                    } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u60C5\u5831\u3084\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u306E\u30C7\u30FC\u30BF\u306F\u524A\u9664\u3055\u308C\u307E\u3059\u304C\u3001\u81EA\u5206\u53F2\u3001\u8A18\u4E8B\u3001Q&A\u306E\u30C7\u30FC\u30BF\u306F\u524A\u9664\u3055\u308C\u307E\u305B\u3093\u3002"),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(12),
                    } }, "\u6709\u6599\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u53D6\u308A\u6271\u3044"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(8),
                    } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u306B\u4F34\u3044\u3001\u4FDD\u6709\u3057\u3066\u3044\u308B\u30B3\u30A4\u30F3\u3084\u30DD\u30A4\u30F3\u30C8\u3001\u53CA\u3073\u6709\u6599\u30B3\u30F3\u30C6\u30F3\u30C4\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u6A29\u306F\u6D88\u5931\u3057\u307E\u3059\u3002"),
                react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(32) }, fontWeight: "600", title: "\u6B21\u3078", onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.DELETE_ACCOUNT_TWO_SCREEN);
                    } })))));
};
exports.default = DeleteAccountOneScreen;
